import ReactTableBase from "../../Table/ReactTableBase";
import React from "react";
import {Link} from "react-router-dom";
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import {ImageIllustration} from "../../Image/ImageIllustration";
import BtnSwitch from "../../Button/BtnSwitch";
import stylesSwitch from "../../Button/BtnSwitch.module.css";
import RenderCellActif from "../../Table/RenderCellActif";
import RenderCellSplit from "../../Table/RenderCellSplit";
import {getLabel} from "../../../services/LabelService";


const CrmTypeTable = ({ crmtypes, putActifOpenModal = null }) => {
    const data = React.useMemo(() => crmtypes, [crmtypes]);

    const columns = [
        /*{
            Header: 'Id',
            accessor: 'id',
        },*/
        {
            Header: 'Label',
            accessor: 'label',
            Cell: ({value}) => getLabel(value),
        },
        {
            Header: 'Description',
            accessor: 'description',
            Cell: ({value}) => getLabel(value),
        },
        {
            Header: 'Canal',
            accessor: 'canal',
            Cell: ({value}) => getLabel(value),
        },
        {
            Header: 'État',
            accessor: 'actif',
            isBoolean: true,
            Cell: (props) => <RenderCellActif {...props} putActifOpenModal={putActifOpenModal}  />,
        },
        /* {
            Header: 'Actions',
            id: 'actions',
            Cell: renderCellActions,
        } */
    ];

    return (
        <ReactTableBase dataSource={crmtypes} columnsData={columns} />
    );
}

export default CrmTypeTable;